import React, { useRef, useCallback } from 'react'

import './shiki.css'
import './theme.css'

interface CodeBlockProps {
  children: React.ReactNode
}

interface Tooltip {
  visible: boolean
  annotation: string
  error: string
  position: {
    left: number
    top: number
  }
  maxWidth: number
}

export default function CodeBlock(props: CodeBlockProps) {
  const codeRef = useRef<HTMLElement>(null)
  const tooltipRef = useRef<HTMLDivElement>(null)
  const tooltipCodeRef = useRef<HTMLDivElement>(null)

  const handleMouseOver = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {

      if (!codeRef.current) return
      if (!tooltipRef.current) return
      if (!tooltipCodeRef.current) return

      const target = event.target as HTMLElement

      if (
        'DATA-LSP' !== target.nodeName // && 'DATA-ERR-MARK' !== target.nodeName
      ) {
        // hide?
        return
      }

      // Don't bother triggering a react render, just set the style manually
      const lsp = target.getAttribute('lsp')
      // const err = target.getAttribute('error')
      let msgBounds = target.getBoundingClientRect()
      let codeBounds = codeRef.current.getBoundingClientRect()
      let left = msgBounds.left - codeBounds.left

      tooltipRef.current.style.display = 'block'

      tooltipRef.current.style.top = `${msgBounds.top + 20 - codeBounds.top}px`
      tooltipRef.current.style.left = `${left}px`

      tooltipRef.current.style.maxWidth = `${Math.min(
        (3 * codeBounds.width) / 4,
        codeBounds.width - left - 2,
      )}px`

      if (!lsp) return

      tooltipCodeRef.current.innerHTML = lsp
    },
    [],
  )

  const handleMouseOut = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      if (!tooltipRef.current) return

      tooltipRef.current.style.display = 'none'
    },
    [],
  )

  return (
    <div className='code-container'>
      <div className="eui-syntax-highlighting line-numbers">
        <pre className="shiki twoslash">
          <code
            className="code-container"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            ref={codeRef}
          >
            {props.children}
          </code>

        </pre>
        <div className="shiki-twoslash-tooltip" ref={tooltipRef}>
          <pre className="shiki twoslash">
            <code ref={tooltipCodeRef} />
          </pre>
        </div>
      </div>
    </div>
  )
}
